<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="shrink-0"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <!-- Metronome Body / Pyramid Outer Frame -->
    <path d="M7.5 21L10.2 4.5C10.4 3.6 11.1 3 12 3C12.9 3 13.6 3.6 13.8 4.5L16.5 21" />
    <path d="M5.5 21H18.5" />
    
    <!-- Base Tray Cutout Line -->
    <path d="M8 17.5H16" stroke-width="1.6" />

    <!-- Swinging Inverted Pendulum Rod (Angled) -->
    <path d="M12 18L16.2 7" stroke-width="2.2" stroke="currentColor" />

    <!-- Sliding Tempo Weight on Pendulum Rod -->
    <rect
      x="13.7"
      y="8.8"
      width="3.2"
      height="3.8"
      rx="0.8"
      fill="currentColor"
      stroke="none"
      transform="rotate(25 15.3 10.7)"
    />

    <!-- Tick Accent Arc -->
    <path d="M8.5 8.5C9.5 7.5 10.7 7 12 7" stroke-width="1.6" />
  </svg>
</template>

<script setup>
</script>
